<template>
  <c-box
    user-select="none"
    :border-radius="{ sm: 'base' }"
    :bg="{ sm: 'white' }"
    :px="{ sm: 'md', md: 'xl', lg: '2xl', xl: '4xl' }"
  >
    <details
      :d="{ sm: 'none' }"
      v-chakra="{
        '& .instructions-icon': {
          transition: 'transform 0.1s ease-in-out',
        },

        '&[open] .instructions-icon': {
          transform: 'rotate(-90deg) translate(-0px, 0)',
        },
      }"
    >
      <summary
        v-chakra="{
          '&::marker': {
            content: '\'\'',
          },
        }"
      >
        <c-icon name="chevron_right" size="1.2rem" class="instructions-icon" mr="0.3rem" />
        <c-heading
          as="h2"
          fontSize="1rem"
          color="brand.purple"
          overflow-wrap="anywhere"
          display="inline-block"
          font-weight="normal"
          mb="0"
        >
          {{ $t("common.instructions") }}
        </c-heading>
      </summary>
      <ol v-chakra ml="lg">
        <li>
          <p>{{ $t("support.processPhases.createLabel") }}</p>
        </li>
        <li>
          <p>{{ $t("support.processPhases.packProducts") }}</p>
        </li>
        <li>
          <p>{{ $t("support.processPhases.deliverToPickup") }}</p>
        </li>
        <li>
          <p>{{ $t("support.processPhases.iloqHandling") }}</p>
        </li>
      </ol>
    </details>
    <c-box :d="{ base: 'none', sm: 'block' }" max-width="60rem" m="0 auto">
      <c-grid
        template-columns="2fr 1fr 2fr 1fr 2fr 1fr 2fr"
        :align-items="{ base: 'flex-end', md: 'flex-start', xl: 'baseline' }"
        v-chakra="{
          '& .long': {
            display: { base: 'none', md: 'block' },
          },
          '& .short': {
            display: { base: 'grid', md: 'none' },
          },
          '& img': {
            width: '100%',
            margin: 0,
            padding: 0,
          },
          '& .separator': {
            height: '100%',
            backgroundImage: 'url(\'/img/support/returns/separator_arrow.jpg\')',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white',
          },
        }"
      >
        <c-box py="xl">
          <c-image
            src="/img/support/returns/step1.png"
            :alt="$t('support.processPhases.createLabelShort')"
            max-width="9rem"
          />
          <span class="long">1. {{ $t("support.processPhases.createLabel") }}</span>
          <span class="short">{{ $t("support.processPhases.createLabelShort") }}</span>
        </c-box>
        <c-box class="separator"></c-box>
        <c-box py="xl" pl="xl">
          <c-image
            src="/img/support/returns/step2.png"
            :alt="$t('support.processPhases.packProductsShort')"
          />
          <span class="long">2. {{ $t("support.processPhases.packProducts") }}</span>
          <span class="short">{{ $t("support.processPhases.packProductsShort") }}</span>
        </c-box>
        <c-box class="separator"></c-box>
        <c-box py="xl" pl="xl">
          <c-image
            src="/img/support/returns/step3.png"
            :alt="$t('support.processPhases.deliverToPickupShort')"
          />
          <span class="long">3. {{ $t("support.processPhases.deliverToPickup") }}</span>
          <span class="short">{{ $t("support.processPhases.deliverToPickupShort") }}</span>
        </c-box>
        <c-box class="separator"></c-box>
        <c-box py="xl" pl="xl">
          <c-image
            src="/img/support/returns/step4.png"
            :alt="$t('support.processPhases.iloqHandlingShort')"
          />
          <span class="long">4. {{ $t("support.processPhases.iloqHandling") }}</span>
          <span class="short">{{ $t("support.processPhases.iloqHandlingShort") }}</span>
        </c-box>
      </c-grid>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { CBox, CGrid, CHeading, CIcon, CImage } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "RMAProcessSteps",
  components: {
    CIcon,
    CBox,
    CImage,
    CHeading,
    CGrid,
  },
});
</script>
